<span class="app-avatar" [attr.aria-label]="name || label || 'User'">{{ initials }}</span>